import { fmtTime } from "../components/geotab/geotabFormat.js";

// Écarts Geotab d'une journée passée : textes des lignes de la liste Geotab, de l'en-tête du lecteur et du survol du compteur
// des lignes du Gantt. Le répartiteur se repère aux noms des lieux de chargement et de livraison, jamais aux numéros de commande.

export const CHECK_CASES = {
  unassigned: { label: "Commande sans tournée", className: "bg-[#9c3b31] text-white" },
  pm: { label: "Chargé PM non prévu", className: "bg-[#f2c94c] text-slate-900" },
  none: { label: "Hors Dispatch", className: "bg-[#6d4c9f] text-white" },
  missed: { label: "Arrêt prévu pas vu", className: "bg-[#b91c1c] text-white" },
};

const STOP_ROLES = { loading: "chargement", delivery: "livraison", stop: "arrêt" };

const MONTHS = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];

// « 2026-10-08 » → « 8 oct. », « 2026-10-01 » → « 1er oct. ».
export function shortDay(isoDate) {
  const [, month, day] = String(isoDate || "").slice(0, 10).split("-").map(Number);
  return month && day ? `${day}${day === 1 ? "er" : ""} ${MONTHS[month - 1]}` : "";
}

// Heure locale d'un horodatage ISO : « 15 h 35 ».
function clockOf(iso) {
  const at = new Date(iso);
  return Number.isNaN(at.getTime()) ? "" : `${at.getHours()} h ${String(at.getMinutes()).padStart(2, "0")}`;
}

function localDay(iso) {
  const at = new Date(iso);
  return Number.isNaN(at.getTime()) ? "" : `${at.getFullYear()}-${String(at.getMonth() + 1).padStart(2, "0")}-${String(at.getDate()).padStart(2, "0")}`;
}

const list = (names) => names.filter(Boolean).join(", ");

// Ce que c'est probablement (what) et ce qui le montre (proof).
export function checkItemText(item, dispatchDate) {
  const clients = list(item.clients || []);
  const mills = list(item.mills || []);
  if (item.case === "unassigned") {
    const plural = (item.order_count || 1) > 1;
    const loaded = (item.stops || []).some((stop) => stop.role === "loading");
    const what = loaded && mills ? `${mills} → ${clients}.` : `Livraison ${clients}${mills ? `, chargée à ${mills}` : ""}.`;
    const added = item.created_at && localDay(item.created_at) === dispatchDate;
    const proof = added
      ? `Commande${plural ? "s" : ""} ajoutée${plural ? "s" : ""} le ${shortDay(dispatchDate)} à ${clockOf(item.created_at)}, placée${plural ? "s" : ""} sur aucun camion.`
      : `Commande${plural ? "s" : ""} du ${shortDay(dispatchDate)} placée${plural ? "s" : ""} sur aucun camion.`;
    return { what, proof };
  }
  if (item.case === "pm") {
    return {
      what: clients
        ? `Chargement pour ${clients}, prévu le ${shortDay(item.next_date)} sur ce camion.`
        : `Chargement prévu le ${shortDay(item.next_date)} sur ce camion.`,
      proof: "",
    };
  }
  const what = (item.stops || []).length > 1 ? "Aucune commande pour ce trajet." : "Aucune commande à ce lieu ce jour-là.";
  const proofs = [];
  if (item.other) {
    proofs.push(`${item.other.site} était prévu sur ${item.other.truck_name}${item.other.arrival != null ? `, livré à ${fmtTime(item.other.arrival)}` : ""}. Un 2e voyage ?`);
  }
  if (item.next_date) proofs.push(`Prévu le ${shortDay(item.next_date)} sur ce camion : fait en avance ?`);
  return { what, proof: proofs.join(" ") };
}

// Survol du compteur Geotab d'une ligne du Gantt : qui, quoi, où, à quelle heure.
export function checkHoverLine(item) {
  const stops = item.stops || [];
  const first = stops[0] || {};
  const last = stops[stops.length - 1] || first;
  const where = stops.length > 1
    ? `${first.place} → ${last.place}`
    : `${STOP_ROLES[first.role] || "arrêt"} ${first.place}`;
  return { who: item.driver || item.truck_name, where: `${where} à ${fmtTime(first.arr)}`, kind: CHECK_CASES[item.case]?.label || "" };
}
